import { useState, useEffect } from "react";
import cx from "classnames";
import styles from "./IEDeprecationBanner.module.scss";

type Props = {
  className?: string;
};

const IEDeprecationBanner = ({ className }: Props) => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    const ie10OrOlder = userAgent.includes("MSIE ");
    const ie11 = userAgent.includes("Trident/");

    if (ie10OrOlder || ie11) {
      setShowBanner(true);
    }
  }, []);

  if (!showBanner) {
    return null;
  }

  return (
    <aside
      className={cx(styles.root, className)}
      aria-label="The Atlantic no longer supports the Internet Explorer browser."
    >
      <p className={styles.text}>
        <i>The Atlantic</i>{" "}
        <a
          href="https://support.theatlantic.com/hc/en-us/articles/360011224573-Supported-web-browsers"
          className={styles.link}
        >
          no longer supports the Internet Explorer browser
        </a>
        . For a faster and better experience on our site, please use the latest
        version of Google Chrome, Safari, Firefox, or Microsoft Edge.
      </p>
    </aside>
  );
};

export default IEDeprecationBanner;
